import { useRef } from 'react'

const FreezeProps = function ({ freeze, Component, ...props }) {
  const prevProps = useRef()
  if (freeze) {
    prevProps.current =
      prevProps.current !== undefined ? prevProps.current : props
    return <Component {...prevProps.current} />
  }
  prevProps.current = undefined
  return <Component {...props} />
}

export default FreezeProps
